<template>
	<div class="tw-text-center">
		<p>Recuerde que 4 competencias corporativas serán evaluadas en todos los puestos</p>
		<div class="tw-text-left tw-text-app-color-secondary">Procedimiento</div>
		<div class="tw-mb-8 tutorial-content tw-p-8">
			<div class="content-row tw-mb-4">
				<div>Paso 1:</div>
				<div>
					<span class="tw-text-app-color-secondary">Escoger Competencias</span>
					<p class="tw-mb-1">Se deben escoger las competencias:</p>
					<ul>
						<li>4 competencias de tipo corporativas</li>
						<li>2 competencias de tipo área</li>
						<li>3 competencias de tipo puesto</li>
					</ul>
				</div>
			</div>
			<div class="content-row">
				<div>Paso 2:</div>
				<div>
					<span class="tw-text-app-color-secondary">Escoger Nivel</span>
					<p class="tw-mb-1">Para cada competencia escoger un nivel:</p>
					<ul>
						<li>Táctica</li>
						<li>Estratégico</li>
						<li>Operativo</li>
					</ul>
				</div>
			</div>
		</div>
		<three-sixty-help :moduleConfiguration="moduleConfiguration"></three-sixty-help>
	</div>
</template>
<script>
import { mapState } from 'vuex';
import { pathOr } from 'ramda';
import ThreeSixtyHelp from '../../../commons/three-sixty-help';
import { THREE_SIXTY_EVALUATION_NAMESPACE } from '../../../store/store.constant';

export default {
	components: { ThreeSixtyHelp },
	name: 'RequiredSkillsTutorialSection',
	computed: {
		...mapState(THREE_SIXTY_EVALUATION_NAMESPACE, {
			moduleConfiguration: pathOr([], ['moduleConfiguration']),
		}),
	},
};
</script>

<style lang="scss" scoped>
.tutorial-content {
	border: 1px solid var(--app-color-gray);
	background-color: #f9f9f9;
	border-radius: 5px;
	.content-row {
		width: 100%;
		display: flex;
		gap: 10px;
		& > :first-child {
			width: 10%;
		}
		& > :last-child {
			width: 90%;
			text-align: left;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/second-step/components/required-skills-tutorial-section.vue